import api from "../../components/services/api";
import { useParams } from "react-router";
import { useState } from "react";
import { useEffect } from "react";
import moment from "moment";
import "./SaleOrder.css";
export default function BookingDetailsReceived() {
  let { id } = useParams();
  const [locationData, setLocationData] = useState([]);
  const [container, setContainer] = useState([]);
  const [packageData, setPackageData] = useState([])
  const [freightForwarderData, setFreightForwarderData] = useState([])
  const [statusSO_data, setStatusSo_data] = useState([]);
  const [forwarderData, setForwarderData] = useState([])
  const [commodityData, setCommodityData] = useState([])
  const [containerData, setContainerData] = useState([])
  const [factoryData, setFactoryData] = useState([])
  const [linersData, setLinersData] = useState([])

  const [data, setData] = useState();
  const [transportation, setTransportation] = useState();
  const getData = async () => {
    const res = await api(`api/saleorder/detail/bookinginfo/${id}`);
    const data = await res.data;
    setData(data);
  };
  const getFactoryList = async () => {
    try {
      const res = await api.get("api/factory/list");
      const data = await res.data
      if (res.meta.status === true) {
        setFactoryData(data.filter((x) => x?.Status === true))
      }
    } catch (e) {
      console.log(e);
    }
  };
  const getContaier = async () => {
    try {
        const res = await api.get("api/container/list");
        const data = await res.data
        if (res.meta.status === true) {
            setContainerData(data.filter((x) => x?.Status === true));
        }
    } catch (e) {
        console.log(e);
    }
};
  const getCommodity = async () => {
    try {
        const res = await api.get("api/commodity/list");
        const data = await res.data
        if (res.meta.status === true) {
            setCommodityData(data.filter((x) => x?.Status === true));
        }
    } catch (e) {
        console.log(e);
    }
};
  const getForwarderData = async () => {
    const params = {
        cusType: 1,
    };
    try {
        const res = await api.post("api/customer/list", params);
        const data = await res.data
        if (res.meta.status === true) {
            setForwarderData(data.filter((x) => x?.Status === true));
        }
    } catch (e) {
        console.log(e);
    }
};

  const getTransportation = async () => {
    const res = await api(`api/saleorder/detail/transportation/${id}`);
    const data = await res.data;
    setTransportation(data);
  };
  const getMasterPackage = async () => {
    try {
      const res = await api.get("api/master/package");
      const data = await res.data
      if (res.meta.status === true) {
        setPackageData(data.data)
      }
    } catch (e) {
      console.log(e);
    }
  };
  const getLocation = async () => {
    try {
      const res = await api.get("api/location/list");
      const data = await res.data
      if (res.meta.status === true) {
        setLocationData(data);
      }
    } catch (e) {
      console.log(e);
    }
  };
  const getFreightForwarder = async () => {
    try {
      const res = await api.get("api/master/freightforwarder");
      const data = await res.data
      if (res.meta.status === true) {
        setFreightForwarderData(data)
      }
    } catch (e) {
      console.log(e);
    }
  };
  const getContainer = async () => {
    const res = await api(`api/saleorder/detail/container/${id}`);
    const data = await res.data;
    setContainer(data);
  };
  const FetchStatusSo = async () => {
    try {
      const res = await api.get("api/master/saleorder/status");

      setStatusSo_data(res.data);
    } catch (e) {
      console.log(e);
    }
  };
  const getLiners = async () => {
    try {
        const res = await api.get("api/liners/list");
        const data = await res.data
        if (res.meta.status === true) {
            setLinersData(data.filter((x) => x?.Status === true));
        }
    } catch (e) {
        console.log(e);
    }
};
  useEffect(() => {
    getData()
    getTransportation()
    getLocation()
    getContainer()
    getMasterPackage()
    getFreightForwarder()
    FetchStatusSo()
    getForwarderData()
    getCommodity()
    getContaier()
    getFactoryList()
    getLiners()

  }, [])

  // const pageCount = Math.ceil(data?.detail?.length / 6)
  const pageCount = 1
  const rows = [];
  for (let pageIndex = 0; pageIndex < pageCount; pageIndex++) {
    rows.push(<>
      <page>
        <div class="header">
          <img src="/images/logo2.png" class="logo" style={{ width:200 }} />

        </div>
        <div class="content">
          <div style={{ marginBottom: '10px' }}>
            <p style={{ marginBottom: '0px' }}>Dear Customer</p>
            <p style={{ marginBottom: '0px' }}>The following booking details have heen received</p>
          </div>
          <div className="rowR">

          </div>
          <div class="rowR full" style={{ background: "#d7dde5" }}>
            <p className="header_p" style={{ fontSize: '20px' }}>Notification Summary</p>
            <p> </p>
          </div>
          <div className="rowR full">
            <p className="header_p">Shipping Line/FreightForwarder: </p>
            <p> {freightForwarderData?.find((x) => x?.FreightForwarderId === data?.FreightForwarderId)?.FreightForwarderName || '-'}</p>
          </div>
          <div className="rowR full">
            <p className="header_p">Booking Number: </p>
            <p> {data?.BookingNo || '-'}</p>
          </div>
          <div className="rowR full">
            <p className="header_p">Shipper Referenece Number: </p>
            <p> {data?.ShipperRefNo || '-'}</p>
          </div>
          <div className="rowR full">
            <p className="header_p">Customer Referenece Number: </p>
            <p> {data?.CustomerCode || '-'}</p>
          </div>
          <div className="rowR full">
            <p className="header_p">* Booking Status: </p>
            <p> {statusSO_data?.find((x) => x?.TypeSaleOrderId == data?.SaleOrderStatus)?.TypeName  || '-'}</p>
          </div>
          <div className="rowR full">
            <p className="header_p">* Booking Status Remarks: </p>
            <p> {''}</p>
          </div>
          <div className="rowR full">
            <p className="header_p">Transportation Customer Required: </p>
            <p> {''}</p>
          </div>

        </div>
        <div class="content">
          <div class="rowR full" style={{ marginBottom: '5px', background: "#d7dde5" }}>
            <p className="header_p" style={{ fontSize: '20px', background: "#d7dde5" }}>Booking Details</p>
            <p> </p>
          </div>
          <div class="rowR full" style={{ background: "#e7e7e7" }}>
            <p className="header_p">Paertles</p>
            <p> </p>
          </div>
          <div className="rowR full">
            <p className="header_p" style={{flexBasis:"15%"}}>Forwarding Name: </p>
            <p> {data?.ForwardingName || '-'}</p>
          </div>
          <div className="rowR full">
            <p className="header_p" style={{flexBasis:"15%"}}>Shipper Name: </p>
            <p>{linersData?.find((x) => x?.LinersId === data?.LinersId)?.LinersName || '-'}</p>
          </div>
          <div className="rowR full">
            <p className="header_p" style={{ fontWeight: '600', flexBasis:"15%" }}>Factory Name: </p>
            <div style={{ display: "flex", flexWrap: 'wrap', flexBasis: '85%' }}>

              {transportation?.StuffingPlan?.map((x, i) => (
                <span style={{ marginRight: '10px' }}>{factoryData?.find((y) => y?.FactoryId === x?.FactoryId)?.FactoryName}</span>
              ))}
            </div>
          </div>

        </div>
        <div class="content">
          <div class="rowR full" style={{ background: "#e7e7e7" }}>
            <p className="header_p">Routing</p>
            <p> </p>
          </div>
          <div class="rowR">
            <p className="header_p" style={{ flexBasis: '50%' }} >Gate Out:</p>
            <p> {locationData?.find((x) => x?.LocationId === transportation?.OutboundGateOutId)?.LocationName || '-'}</p>
          </div>
          <div className="rowR">
            <p className="header_p" style={{ flexBasis: '50%' }}>Gate In: </p>
            <p> {locationData?.find((x) => x?.LocationId === transportation?.InboundGateOutId)?.LocationName || '-'}</p>
          </div>
          <div className="rowR">
            <p className="header_p" style={{ flexBasis: '50%' }}>(Estimated) Departrue Date: </p>
            <p> {transportation?.InboundETDGateOut ? moment(transportation?.InboundETDGateOut).format('DD/MM/YYYY') : '-'}</p>
          </div>
          <div className="rowR">
            <p className="header_p" style={{ flexBasis: '50%' }}>(Estimated) Arrival Date: </p>
            <p> {transportation?.InboundETAGateIn ? moment(transportation?.InboundETAGateIn).format('DD/MM/YYYY') : '-'}</p>
          </div>
          <div className="rowR">
            <p className="header_p" style={{ flexBasis: '50%' }}>Voyage: </p>
            <p> {transportation?.InboundVoyNo || '-'}</p>
          </div>
          <div className="rowR">
            <p className="header_p"></p>
            <p> {locationData?.find((x) => x?.LocationId === transportation?.OutboundGateOutId)?.LocationName || '-'}</p>
          </div>
          <div class="rowR">
            <p className="header_p" style={{ flexBasis: '50%' }} >Gate Out:</p>
            <p> {locationData?.find((x) => x?.LocationId === transportation?.InboundGateOutId)?.LocationName || '-'}</p>
          </div>
          <div className="rowR">
            <p className="header_p" style={{ flexBasis: '50%' }}>Gate In: </p>
            <p> {''}</p>
          </div>
          <div className="rowR">
            <p className="header_p" style={{ flexBasis: '50%' }}>(Estimated) Departrue Date: </p>
            <p> {transportation?.InboundETDGateOut ? moment(transportation?.InboundETDGateOut).format('DD/MM/YYYY') : '-'}</p>
          </div>
          <div className="rowR">
            <p className="header_p" style={{ flexBasis: '50%' }}>(Estimated) Arrival Date: </p>
            <p> {transportation?.InboundETAGateIn ? moment(transportation?.InboundETAGateIn).format('DD/MM/YYYY') : '-'}</p>
          </div>
          <div className="rowR">
            <p className="header_p" style={{ flexBasis: '50%' }}>Voyage: </p>
            <p> {transportation?.InboundVoyNo || '-'}</p>
          </div>
          <div className="rowR">
            <p className="header_p"></p>
            <p> </p>
          </div>
          <div className="rowR">
            <p className="header_p" style={{ flexBasis: '50%' }}>Port of Load: </p>
            <p>{locationData?.find((x) => x?.LocationId === data?.POLLocationId)?.LocationName || '-'}</p>

          </div>
          <div className="rowR">
            <p className="header_p" style={{ flexBasis: '50%' }}>Port of Discharge: </p>
            <p>  {locationData?.find((x) => x?.LocationId === data?.PODLocationId)?.LocationName || '-'}</p>
          </div>
          <div className="rowR">
            <p className="header_p" style={{ flexBasis: '50%' }}>First Service/Vessle/<br />Voyage/Direction: </p>
            <p> {data?.FeederVessel || '-'}</p>
          </div>


        </div>
        <div class="content">

          <div class="rowR full" style={{ background: "#e7e7e7" }}>
            <p className="header_p" >Container and Cargo</p>
            <p> </p>
          </div>
          <div className="rowR full">
            <p className="header_p">Container Quantity And <br /> Container Type: </p>
            <p> {data?.Quantity || 0} x {containerData?.find((x) => x?.ContainerTypeId === data?.ContainerTypeId)?.ContainerTypeName }</p>
          </div>
          <div className="rowR full">
            <p className="header_p">Cargo Commodity: </p>
            <p> {commodityData?.find((x) => x?.CommodityId === data?.CommodityId)?.CommodityName ||'-'}</p>
          </div>
          <div className="rowR full">
            <p className="header_p" >Packaging: </p>
            <p> {packageData?.find((x) => x?.PackageId === data?.PackageId)?.PackageName || '-'}</p>
          </div>

        </div>
        <div class="content">

          <div class="rowR full" style={{ background: "#e7e7e7" }}>
            <p className="header_p" >Required Document</p>
            <p> </p>
          </div>
        </div>
        <div class="containerR">

          <table border="1" cellpadding="10" cellspacing="0">
            <tr style={{ border: "1px solid" }}>
              <th style={{ border: "1px solid" }}>Document Type</th>
              <th style={{ border: "1px solid" }}>Required Uploard Party</th>
              <th style={{ border: "1px solid" }}>Due Date</th>
            </tr>

            <tr
              style={{
                border: "1px solid",
                fontSize: "16px",
                height: "27px",
              }}
            >
              <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[0]?.Code}</td>
              <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[0]?.ServiceDescription}</td>
              <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[0]?.Size}</td>
            </tr>

            <tr
              style={{
                border: "1px solid",
                fontSize: "16px",
                height: "27px",
              }}
            >
              <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[0]?.Code}</td>
              <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[0]?.ServiceDescription}</td>
              <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[0]?.Size}</td>
            </tr>

            <tr
              style={{
                border: "1px solid",
                fontSize: "16px",
                height: "27px",
              }}
            >
              <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[0]?.Code}</td>
              <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[0]?.ServiceDescription}</td>
              <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[0]?.Size}</td>
            </tr>
            <tr
              style={{
                border: "1px solid",
                fontSize: "16px",
                height: "27px",
              }}
            >
              <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[0]?.Code}</td>
              <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[0]?.ServiceDescription}</td>
              <td style={{ border: "1px solid" }}>{data?.detail?.slice(pageIndex * 6, pageIndex * 6 + 6)[0]?.Size}</td>
            </tr>
          </table>
        </div>


        <div class="footer_S">
          <p style={{ fontSize: "20px", }}>For any cargo tracking and schedule, please logon <a style={{ color: "#2f9eff", textDecoration: 'underline' }}>https://sritrang.kivaru.com/login</a></p>
          <p></p>
        </div>
      </page>
    </>
    )
  }
  return (

    <>
      {rows}
    </>

  );
}
